<!--能源结构（卡片数据，半圆仪表盘，多环形图）-->
<template>
  <div class="energystructure commonborder flex_row">
    <div class="left flex_column">
      <div class="top">
        <div class="title">全年总能耗（吨标煤）</div>
        <div class="numberbox">
          <span v-for="(item,index) in total" :key="index">{{item}}</span>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="title">绿色能源占比</div>
        <div ref="energystructure_gauge" class="echarts"></div>
      </div>
    </div>
    <div class="right">
      <div ref="energystructure_pie1" class="echarts"></div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      total:'',
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getStructure().then(res=>{
        if(res.code==10000){
          let total = res.data.totalEnergy.toString()
          this.total = total.split('')
          this.myfun(
            res.data.marketMix,
            res.data.windMix,
            res.data.afterheatMix,
            res.data.lightMix,
          );
          this.energystructure_gauge(res.data.greenMix)
        }
      })
    },
    myfun(a,b,c,d) {
      var chartDom = this.$refs.energystructure_pie1;
      var myChart = echarts.init(chartDom);
      var data = [
        {
          name: "市电",
          value: a,
        },
        {
          name: "风电",
          value: b,
        },
        {
          name: "余热",
          value: c,
        },
        {
          name: "光伏",
          value: d,
        },
      ];

      var titleArr = [];
      var seriesArr = [];
      var colors = [
        ["#00bcff", "#0c2667"],
        ["#f4af1b", "#0c2667"],
        ["#ae74f3", "#0c2667"],
        ["#fc5976", "#0c2667"],
      ];
      data.forEach( (item, index) =>{

        titleArr.push({
          text: item.name,
          x: index%2 === 0 ?  27 + "%" :  68 + "%",
          y: index > 1 ? "84%" : "37%",
          textAlign: "center",
          textStyle: {
            fontWeight: "normal",
            fontSize: this.$echartsFontSize,
            // color: colors[index][0],
            color:'#ccd0f2',
            textAlign: "center",
          },
        });
        seriesArr.push({
          type: "pie",
          clockWise: false,
          radius: ['20%', '25.5%'],
          itemStyle: {
            normal: {
              color: colors[index][0],
              shadowColor: colors[index][0],
              shadowBlur: 0,
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          hoverAnimation: false,
          center: [
            index%2 === 0 ?  30 + "%" :  70 + "%",
            index > 1 ? "70%" : "22%",
          ],
          data: [
            {
              value: 100 - item.value,
              name: "invisible",
              itemStyle: {
                normal: {
                  color: colors[index][1],
                },
                emphasis: {
                  color: colors[index][1],
                },
              },
            },
            {
              value: item.value,
              label: {
                normal: {
                  formatter: function (params) {
                    return params.value + "%";
                  },
                  position: "center",
                  show: true,
                  textStyle: {
                    fontSize: this.$echartsFontSize+6,
                    fontWeight: "bold",
                    // color: colors[index][0],
                    color:'#fff'
                  },
                },
              },
            },
          ],
        });
      });
      var option = {
        title: titleArr,
        series: seriesArr,
      };
      myChart.setOption(option);
    },
    energystructure_gauge(a){
      var chartDom = this.$refs.energystructure_gauge;
      var myChart = echarts.init(chartDom);
      var dataV = a;
      var option = {
          title: [{
              text: dataV + "%",
              x: 'center',
              top: '36%',
              textStyle: {
                  color: "#fff",
                  fontSize: this.$echartsFontSize+10, //表盘上的标题文字大小
                  fontWeight: 'bold',
              },
          }],
          series: [{
              name: '内仪表盘',
              type: 'gauge',
              center: ['48%', '60%'],
              radius: "120%",
              startAngle: 180,
              endAngle: 0,
              min: 0,
              max: 100,
              splitNumber:1,
              pointer: {
                  show: false //指针
              },
              axisLine: { //大刻度
                  show: true,
                  lineStyle: {
                      width: 20,
                      color: [
                          [dataV / 100, new echarts.graphic.LinearGradient(
                              0, 0, 1, 0, [{
                                  offset: 0,
                                  color: '#00b776',
                              }, {
                                  offset: 0.5,
                                  color: '#0ed28c',
                              }, ]
                          )],
                          [1, "#0c2667"]
                      ]
                  }
              },
              axisTick: {
                  show: false //小刻度
              },
              splitLine: { //隐藏0和100旁边的白色刻度
                  show: false
              },
              axisLabel: {
                  show: true,
                  distance: -35, //距离刻度的距离
                  color: '#ccd0f2',fontSize: this.$echartsFontSize,
                  formatter: function(v) {
                      if (v == "") {
                          return '\xa0' + v;
                      }
                      return v;
                  }
              },
              detail: {
                  show:false,
              },
              data: [{
                  value: dataV
              }]

          }]
      };
      
      myChart.setOption(option);
    }
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.energystructure {
  & > .left {
    width: 55%; height: 100%;
    overflow: hidden;
    &>.top{ height: 40%;
      .numberbox{ text-align: center;
        span{ display: inline-block; background: rgba(0,0,0,.1); box-shadow: 0 0 5px rgba(0,188,255,.8) inset;
          border-radius: 5px; overflow: hidden; font-family: 'DS-DIGI'; font-size: 1.6rem; margin: 2px; color: #fff; font-weight: bold;
          border:1px solid transparent; width: 1.4rem; height: 2rem; line-height: 2rem; text-align: center;
          background-clip:padding-box,border-box;
          background-origin:padding-box,border-box;
          background-image:linear-gradient(#0720a0,#0720a0),linear-gradient(#0720a0,#00bcff);
        }
      }
    }
    &>.bottom{ height: 60%;}
    .title{ text-align: center; margin-top: 1rem;}
  }
  & > .right {
    width: 45%; height: 100%;
    overflow: hidden;
  }
}
</style>